module.exports = __webpack_public_path__ + "static/cad-designs19-d8851dfdb49df961e6432ed89148608a.png";